<template>
    <div class="popup popup-rule" id="paySuccessShorex" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  style="display: block;">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>升级精品游</p>
            <a class="shorexDetail-returnButton" @click="onGoBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="pop-content" style="height: 100%;overflow: scroll;padding-bottom:50px;">
            <div class="shorex-content">
                <div class="pop-img">
                    <div class="pop-sight">
                        <img src="https://resource.rcclchina.com.cn/shorex/shorex-title-mobile.png" alt="">
                    </div>
                    <div class="rule-item">
                        <div class="rule-item-line"></div>
                        <p>请在线升级付费精品游套餐</p>
                        <p>
                        </p>
                    </div>
                </div>
                <div class="shorex-body">

                    <div class="shorex-list" v-for="(cruise, i) in cruises" :key="('cruise_' + i)">
                        <div class="list-item" >
                            <div class="item-title" v-if="getCruise(cruise.shipCode, cruise.sailDate)">{{getCruise(cruise.shipCode, cruise.sailDate).cruiseName}}</div>
                            <div class="item-sub">每张订单<span>仅可选择1种</span> 皇家精品游套餐</div>
                            <div class="shorex-item" v-for="(shorex, j) in cruise.shorexes" :key="('shorex_'+i+'_'+j)">
                                <div class="item-intro">
                                    {{shorex.shorexName}} <span class="num">{{shorex.price}}</span> <span class="txt">美元/人</span>
                                    <span class="line"></span>
                                    <span class="select" @click="showSelectBooking(cruise.shipCode, cruise.sailDate, shorex.id)">选择订单</span>
                                </div>
                                <div class="out-content">
                                    <div class="item-order" v-show="getSelectBookingsByShorexId(shorex.id).length > 0">
                                        <div class="sub-title">已选订单:</div>
                                        <div class="order-detail" >
                                            <div v-for="(booking) in getSelectBookingsByShorexId(shorex.id)" :key="booking.id">
                                                <div class="code"> 订单号：{{booking.bookingId}}
                                                    <img class="cleanImg" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg"
                                                    @click="removeBookingShorex(shorex.id, booking.id)">
                                                </div>
                                                <div class="info"> 乘客信息：{{getGuestName(booking)}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="singal-img" v-for="(tour) in shorex.shorexTours" :key="tour.shorexRelationId">
                                        <img style="width: 320px"
                                            :src="tour.image"
                                            alt="">
                                        <div class="introduce">
                                            <span>{{tour.shorexName}} </span>
                                            <img class="time-css" src="https://resource.rcclchina.com.cn/RcclHP/time-jpg.jpg">
                                            时长: {{tour.duration}}
                                        </div>
                                        <p class="desc" v-html="tour.shorexDescription"></p>
                                        <p class="desc" v-html="tour.introWarningText"></p>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="foot">
                    <div class="no">注:</div>
                    <div class="no-item">
                        <div>1) 行程与时长仅供参考，以地接社实际接待为准。</div>
<!--                        <div>2) 关于岸上观光产品的咨询、预定和修改,您可通过拨打400-820-3187和皇家加勒比游轮度假专家来联系</div>-->
                    </div>
                </div>
            </div>


        </div>

        <div class="roomDetailModel" v-show="isShowBooking">
            <div class="roomDetail-bg" @click="isShowBooking=false"></div>
            <div class="roomDetailModel-container">
                <div class="pop-title">
                    <p class="o-title">
                        <img style="" src="https://resource.rcclchina.com.cn/RcclHP/Fill.jpg" alt="Alternate Text">
                        请选择需要的订单
                    </p>
                    <p class="o-intro">每张订单<span style="color: #F0777B">仅可选择 <i
                                style="font-style: normal;font-weight: bold;">1</i>种</span>皇家精品游套餐</p>
                </div>
                <div class="pop-list">
                    <div class="order-item" v-for="(booking) in targetCruiseBookings"
                    :key="'targetCruiseBooking_' + booking.id"
                    :class="{ active: isInTempBookings(booking.id)}"
                    @click="setTempBookings(booking)"
                    >
                        <div class="inner-item">
                            <p class="code">订单号: {{booking.bookingId}}</p>
                            <p class="info">乘客信息: {{getGuestName(booking)}}</p>
                        </div>
                    </div>

                </div>
                <div class="roomDetailModel-closed js-closedBtn" @click="isShowBooking=false"><span class="">X</span></div>
            </div>
            <div class="pop-foot">
                <div class="sx comm js-reset" @click="tempBookings=[]">
                    <img style="position: relative;top: 3px;" src="https://resource.rcclchina.com.cn/paySuccess/sx-icon.png" />
                    重置
                </div>
                <div class="qd comm  js-confirm" @click="confirmBookingShorex()">
                    <img style="height: 16px;position: relative;top:3px;"
                        src="https://resource.rcclchina.com.cn/paySuccess/qd-icon.png" />
                    确定
                </div>
            </div>
        </div>

        <PaySuccessShorexBottom
            :selectedShorexes="selectedShorexes"
            :shorexes="shorexes"
        />
    </div>
</template>

<script>
const PaySuccessShorexBottom = () => import('@/components/Booking/PaySuccessShorexBottom')
export default {
    name: "PaySuccessShorex",
    components: {
        PaySuccessShorexBottom
    },
    props: {
        isShow: {
            type: Boolean
        },
        onGoBack: {
            type: Function
        },
        shorexes: {
            type: Array
        },
        bookings: {
            type: Array
        },
        bookingCruises: {
            type: Array
        }
    },
    data () {
        return {
            isShowBooking: false,
            selectedShorexes: [],
            targetCruiseBookings: [],
            targetShorexId: 0,
            tempBookings: []
        }
    },
    methods: {
        showSelectBooking (shipCode, sailDate, shorexId) {
            this.targetCruiseBookings = this.bookings.filter(r=>r.shipCode == shipCode && r.sailDate == sailDate)
            this.targetShorexId = shorexId
            const selectedShorex = this.selectedShorexes.find(r=>r.shorex.id == shorexId)
            if (!selectedShorex) {
                this.tempBookings = []
            } else {
                this.tempBookings = [...selectedShorex.bookings]
            }

            this.isShowBooking = true
        },
        getSelectBookingsByShorexId(shorexId) {
            const selectedShorex = this.selectedShorexes.find(r=>r.shorex.id == shorexId)
            if (!selectedShorex) return []
            return selectedShorex.bookings
        },
        getGuests (booking) {
            return booking.bookingGuests || []
        },
        getGuestName (booking) {
            let guestName = []
            const guests = this.getGuests(booking)
            guests.forEach((guest) => {
                let name = guest.chineseLastName + guest.chineseFirstName
                if (!name || name.length == 0) {
                    name = `${guest.pinYinLastName} ${guest.pinYinFirstName}`
                }
                guestName.push(name)
            })
            return guestName.join(' | ')
        },
        getCruise (shipCode, sailDate) {
            return this.bookingCruises.find(r=>r.shipCode == shipCode && r.sailDate == sailDate)
        },
        // 删除已选订单
        removeBookingShorex(shorexId, bookingRecordId) {
            const selectedShorex = this.selectedShorexes.find(r=>r.shorex.id == shorexId)
            if (!selectedShorex) return
            selectedShorex.bookings = selectedShorex.bookings.filter(r=>r.id != bookingRecordId)
        },
        isInTempBookings(bookingRecordId) {
            return this.tempBookings.some(r=>r.id == bookingRecordId)
        },
        setTempBookings(booking) {
            if (this.isInTempBookings(booking.id)) {
                this.tempBookings = this.tempBookings.filter(r=>r.id != booking.id)
            } else {
                this.tempBookings.push(booking)
            }
        },
        confirmBookingShorex() {
            const shorex = this.shorexes.find(r=>r.id == this.targetShorexId)
            if (!shorex) return
            let selectedShorex = this.selectedShorexes.find(r=>r.shorex.id == this.targetShorexId)
            if (!selectedShorex) {
                selectedShorex = {
                    shorex: shorex,
                    bookings: [...this.tempBookings]
                }
                this.selectedShorexes.push(selectedShorex)
            } else {
                selectedShorex.bookings = [...this.tempBookings]
            }

            // 岸上观光每张订单只能选一个，如果选了其他的话，需要把其他的删掉
            if (this.tempBookings.length > 0) {
                const otherShorexes = this.selectedShorexes.filter(r=>r.shorex.id != this.targetShorexId)
                for (let i = 0; i < this.tempBookings.length; i++) {
                    const booking = this.tempBookings[i]
                    for (let j = 0; j < otherShorexes.length; j++) {
                        const shorex = otherShorexes[j]
                        if (shorex.bookings.some(r=>r.id == booking.id)) {
                            shorex.bookings = shorex.bookings.filter(r=> r.id != booking.id)
                        }
                    }
                }
            }

            this.targetCruiseBookings = []
            this.targetShorexId = 0
            this.tempBookings = []
            this.isShowBooking = false
        }
    },
    computed: {
        cruises () {
            let cruises = []
            this.shorexes.forEach((shorex) => {
                const shipCode = shorex.ship
                const sailDate = shorex.sailDate.substring(0, 10)
                let cruise = cruises.find(r=>r.shipCode == shipCode && r.sailDate == sailDate)
                if (!cruise) {
                    cruise = {
                        shipCode,
                        sailDate,
                        shorexes: [shorex]
                    }
                    cruises.push(cruise)
                } else {
                    cruise.shorexes.push(shorex)
                }
            })
            return cruises
        },

    }
}
</script>

<style lang="less" scoped>
p {
    margin: 0;
}
#paySuccessShorex.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
    z-index: 10401;
}
#paySuccessShorex.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#paySuccessShorex.modal-out {
    transform: translate3d(100%, 0, 0);
}

#paySuccessShorex {
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            img {
                width: 33%;
            }
        }
    }

    .shorex-content {
        .pop-img {
            padding: 55px 0px 0;
            background: white;
            img {
                width: 100%;
                display: block;
            }
            .rule-item {
                display: flex;
                align-items: center;
                padding: 10px 12px;
                font-size: 14px;
                line-height: 20px;
                color: #4A90E2;
                position: relative;
                .rule-item-line {
                    width: 3px;
                    height: 12px;
                    margin-right: 6px;
                    background-color: #4A90E2;
                }
                p {
                    margin: 0;
                    font-weight: bold;
                }
            }
        }

        .shorex-body {
            background: #F6F7F8;
            padding: 10px;
            font-size: 14px;
            .shorex-list {
                background: #fff;
                width: 100%;
                border: 1px solid #FEB803;
                border-top: 3px solid #FEB803;
                padding: 2px 10px 0;
                border-radius: 5px;
                margin-bottom: 10px;
                .list-item {
                    border-bottom: 1px solid #e3e3e3;
                    padding-top: 15px;
                    .item-title {
                        font-size: 14px;
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 3px;
                    }
                    .item-sub {
                        font-size: 12px;
                        color: #666;
                        font-weight: 400;
                        > span {
                            color: #FF5055;
                        }
                    }
                    .item-intro {
                        font-size: 14px;
                        font-weight: bold;
                        color: #333;
                        margin-top: 7px;
                        margin-bottom: 5px;
                        .num {
                            color: #FF5055;
                        }
                        .txt {
                            font-size: 10px;
                            color: #333;
                            font-weight: normal;
                        }
                        .line {
                            position: relative;
                            width: 112px;
                            margin: 0px 5px 0px 5px;
                            height: 0px;
                            display: inline-block;
                            border-bottom: dotted 1px #ccc;
                            top: -3px;
                        }
                        .select {
                            width: 56px;
                            height: 20px;
                            display: inline-block;
                            text-align: center;
                            line-height: 20px;
                            background: #fff;
                            color: #4A90E2;
                            font-size: 10px;
                            border: 1px solid #4A90E2;
                            border-radius: 4px;
                            border-radius: 4px;
                        }
                    }
                    .out-content {
                        .item-order {
                            display: flex;
                            color: #999;
                            .sub-title {
                                font-size: 12px;
                                color: #2A2A2A;
                            }
                            .order-detail {
                                .code {
                                    color: #333;
                                    font-weight: bold;
                                    position: relative;
                                    font-size: 12px;
                                    margin-left: 10px;
                                    img {
                                        width: 11px;
                                        height: 11px;
                                        margin-left: 10px;
                                        position: relative;
                                        top: 1px;
                                    }
                                }
                                .info {
                                    font-size: 12px;
                                    color: #2A2A2A;
                                    margin-left: 10px;
                                }
                            }
                        }

                        .singal-img {
                            > img {
                                margin: 15px 0 5px;
                            }
                            .introduce {
                                color: #4A90E2;
                                margin-bottom: 5px;
                                 > span {
                                    font-weight: bold;
                                }
                                .time-css {
                                    width: 12px;
                                    position: relative;
                                    top: 1px;
                                }
                            }
                            .desc {
                                line-height: 20px;
                                font-size: 12px;
                                padding-bottom: 10px;
                                color: #666;
                            }
                        }
                    }

                }
                .list-item:last-child {
                    border-bottom: 0;
                }
            }
        }

        .foot {
            font-size: 10px;
            display: flex;
            color: #999;
            padding: 10px 23px 10px;
            background: white;
        }
    }

}

.roomDetailModel {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0px;
    z-index: 2222222;
    .roomDetail-bg {
        width: 100%;
        background-color: rgba(0,0,0,.4);
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0px;
    }
    .roomDetailModel-container {
        background-color: #fff;
        border-top: 5px solid #FEBC10;
        padding: 22px 20px 30px 20px;
        position: absolute;
        bottom: 48px;
        width: 100%;
        max-height: 60vh;
        overflow-y: auto;
        .pop-title {
            margin-bottom: 10px;
            .o-title {
                padding-left: 2px;
                font-size: 14px;
                color: #4A90E2;
                letter-spacing: 0;
                img {
                    max-height: 20px;
                    max-width: 18px;
                }
            }
            .o-intro {
                padding-left: 26px;
                font-size: 12px;
                color: #333333;
                letter-spacing: 0;
            }
        }
        .pop-list {
            padding-top: 20px;
            border-top: 1px solid #E5E5E5;
            .order-item {
                background: rgba(229,229,229,0.60);
                border-radius: 3.64px;
                padding: 8px 0 8px 22px;
                font-size: 14px;
                margin-bottom: 10px;
                .code {
                    color: #333333;
                    letter-spacing: 0;
                    line-height: 20px;
                    font-weight: bold;
                }
                .info {
                    color: #2A2A2A;
                    letter-spacing: 0;
                    line-height: 20px;
                }
            }
            .order-item.active {
                background: #4A90E2;
                .code, .info {
                    color: #fff;
                }
            }
        }
        .roomDetailModel-closed {
            width: 38px;
            text-align: center;
            height: 34px;
            line-height: 34px;
            position: absolute;
            top: -4px;
            right: 0px;
            background: #FEBC10;
            border-bottom-left-radius: 8px;
            -webkit-border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
            -webkit-border-bottom-right-radius: 8px;
            span {
                display: inline-block;
                color: #fff;
                font-size: 16px;
                -webkit-transform: scale(1.5,1.3);
                -moz-transform: scale(1.5,1.3);
                -ms-transform: scale(1.5,1.3);
                -o-transform: scale(1.5,1.3);
                transform: scale(1.5,1.3);
            }
        }
    }
    .pop-foot {
        height: 48px;
        display: flex;
        font-size: 14px;
        position: fixed;
        left: 0;
        bottom: 0;
        right: 0;
        .sx {
            color: #999;
            background: #fff;
        }
        .qd {
            color: #454545;
            background: #FCC72E;
        }

        .comm {
            width: 50%;
            line-height: 48px;
            text-align: center;
            img {
                margin-right: 4px;
            }
        }
    }
}


</style>
